const Header:React.FC=()=>
{
    return ( <header id="header"  className="header fixed-top d-flex align-items-center justify-content-center">

    <div  className="d-flex align-items-center justify-content-between">
      <a href="index.html"  className="logo d-flex align-items-center">
        <img src="/assets/img/logo.png"  className="w-auto" alt=""/>
        <span  className="d-none d-lg-block">ChartsTwits</span>
      </a>
  
    </div>

   
    {/* <div  className="input-group w-22">
      <input type="text"  className="form-control box-shadow-none fs-13 border-0 bg-color" placeholder="Search Companies, Crypto, NFTs and @usernames
      " aria-label="Recipient's username" aria-describedby="basic-addon2"/>
      <div  className="input-group-append">
        <span  className="input-group-text border-radius search-bg border-0" id="basic-addon2"><button type="submit" title="Search"  className="border-0 bg-transparent"><i  className="bi bi-search"></i></button></span>
      </div>
    </div> */}
  

    <nav  className="header-nav ms-5">
      <ul  className="d-flex align-items-center">

        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon search-bar-toggle " href="home">
            Home
          </a>
        </li>
        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon search-bar-toggle" href="dashboard">
            Dashboard
          </a>
        </li>
        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon search-bar-toggle " href="trending-stocks">
            Trending
          </a>
        </li>
        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon search-bar-toggle " href="watchlist-stocks">
            Watchlist
          </a>
        </li>
        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon" href="/search">
            <i  className="bi bi-search fs-19"></i>
          </a>
        </li>
        <li  className="nav-item d-block">
          <a  className="nav-link nav-icon">
            <i  className="bi bi-bell fs-19"></i>
            <span  className="badge bg-color_ct badge-number fs-9 rounded-circle">4</span>
          </a>
        </li>

        
       

   
        

        <li  className="nav-item dropdown pe-3">

          <a  className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
            <img src="/assets/img/profile-img.jpg" alt="Profile"  className="rounded-circle"/>
            <span  className="d-none d-md-block dropdown-toggle ps-2 text-white">Smith</span>
          </a>

          <ul  className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li  className="dropdown-header">
              <h6>Kevin Anderson</h6>
              <span>Web Designer</span>
            </li>
            <li>
              <hr  className="dropdown-divider"/>
            </li>

            <li>
              <a  className="dropdown-item d-flex align-items-center" href="users-profile.html">
                <i  className="bi bi-person"></i>
                <span>My Profile</span>
              </a>
            </li>
            <li>
              <hr  className="dropdown-divider"/>
            </li>

            <li>
              <a  className="dropdown-item d-flex align-items-center" href="users-profile.html">
                <i  className="bi bi-gear"></i>
                <span>Account Settings</span>
              </a>
            </li>
            <li>
              <hr  className="dropdown-divider"/>
            </li>

            <li>
              <a  className="dropdown-item d-flex align-items-center" href="pages-faq.html">
                <i  className="bi bi-question-circle"></i>
                <span>Need Help?</span>
              </a>
            </li>
            <li>
              <hr  className="dropdown-divider"/>
            </li>

            <li>
              <a  className="dropdown-item d-flex align-items-center" href="#">
                <i  className="bi bi-box-arrow-right"></i>
                <span>Sign Out</span>
              </a>
            </li>

          </ul>
        </li> 

      </ul>
    </nav> 

  </header>)
}
export  default  Header;